import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

export function logErrorWithPrefix(prefix: string, error: unknown): void {
  console.error(prefix, error);
}

export function navigateAndThrow(router: Router, prefix: string, error: unknown): Observable<never> {
  logErrorWithPrefix(prefix, error);
  router.navigate(['/error']);
  return throwError(() => error);
}
